import { Button } from '@chakra-ui/react'
import { faBell } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import { useUser } from '@/client/context/user'
import { getDashboardLiveHelpUrl } from '@/client/services/url'
import { hasUserRole } from '@/client/services/user'

import ShwLink from '@/components/ShwLink'
import useUnansweredLiveHelpRequestsCount from '@/components/Worlds/hooks/post/useUnansweredLiveHelpRequestsCount'

const MIN_REQUESTS_TO_SHOW_INDICATOR = 1

export default function LiveHelpIndicator({
  tutorWorldIds,
}: {
  tutorWorldIds: number[]
}): JSX.Element | null {
  const user = useUser()

  const { count: activeRequestCount, loading } = useUnansweredLiveHelpRequestsCount({
    tutorWorldIds,
  })

  const isTutor = hasUserRole(user, 'user:tutor')

  if (!isTutor || loading) {
    return null
  }

  if (activeRequestCount < MIN_REQUESTS_TO_SHOW_INDICATOR) {
    return null
  }

  const liveHelpUrl = getDashboardLiveHelpUrl({
    filter: 'waiting-zoom',
    tab: 'give-help',
  })

  return (
    <ShwLink href={liveHelpUrl} display={{ base: 'none', md: 'flex' }}>
      <Button
        bg="primary.solid"
        color="primary.contrast"
        borderRadius="full"
        height="36px"
        px="12px"
        _hover={{ bg: 'primary.emphasized' }}
        leftIcon={
          <FontAwesomeIcon icon={faBell} color={chakraTokenToVar('primary.contrast')} size="sm" />
        }
      >
        {activeRequestCount} Zoom help {activeRequestCount === 1 ? 'request' : 'requests'}
      </Button>
    </ShwLink>
  )
}
